export default "__VITE_ASSET__BNumzIAp__"